import Axios from '../baseApi'

export default {
  async add(model) {
    return await Axios.put('/api-article/v1/articleGroup', model);
  },
  async update(model) {
    return await Axios.post('/api-article/v1/articleGroup', model)
  },
  async delete(id) {
    return await Axios.delete(`/api-article/v1/articleGroup/${id}`);
  },
  async fetchAll() {
    return await Axios.get('/api-article/v1/articleGroup');
  },
  async fetchAssigned(articleId) {
    return await Axios.get(`/api-article/v1/articleGroup/assigned/${articleId}`);
  }
}
